module.exports = __webpack_public_path__ + "img/index-solutions-eea.c016dd9f.png";